<script setup lang="ts">
defineProps<{
  color?: any
}>()
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 35"
    :style="color"
    class="eb-icon-nosize w-10 h-10 p-1"
  >
    <g>
      <path
        d="M11.159,33.807C2.153,30.305-2.307,20.166,1.193,11.158C4.696,2.152,14.837-2.309,23.841,1.195
		c9.006,3.498,13.466,13.643,9.966,22.645C30.304,32.848,20.163,37.307,11.159,33.807"
      />
      <path
        fill="#FFFFFF"
        d="M25.338,22.639H9.64h0.026c-2.89,0-5.23-2.157-5.23-5.045c0-2.889,2.341-5.232,5.23-5.232
		s5.229,2.344,5.229,5.232c0,0.954-0.256,1.852-0.704,2.624v-0.002h6.623l0,0c-0.45-0.771-0.706-1.668-0.706-2.622
		c0-2.889,2.343-5.232,5.229-5.232c2.89,0,5.23,2.344,5.23,5.232C30.568,20.481,28.228,22.639,25.338,22.639z M12.265,17.594
		c0-1.449-1.175-2.623-2.625-2.623c-1.446,0-2.62,1.174-2.62,2.623s1.174,2.622,2.62,2.622
		C11.09,20.216,12.265,19.043,12.265,17.594z M27.938,17.594c0-1.449-1.176-2.623-2.622-2.623c-1.451,0-2.626,1.174-2.626,2.623
		s1.175,2.622,2.626,2.622C26.762,20.216,27.938,19.043,27.938,17.594z"
      />
    </g>
  </svg>
</template>
